'use es6';

import { APPLICATION_SETTINGS_USER_JSLINTER_TOGGLE, APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_UPDATE, APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_ERROR, APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_DEMO_ERRORS } from 'DesignData/actions/ActionTypes';
import { SETTINGS_ESLINT_DEMO_ID, SETTINGS_ESLINTRC_ID } from 'DesignData/constants/settings/ESLint';
import { EMPTY_ARRAY } from 'DesignData/lib/array';
import { getUserSettings as getJSLinterSettings } from 'DesignData/selectors/javaScriptLinter';
import { validateJSON, convertReactCodeMirrorAnnotationToCodeEditorError } from 'DesignData/lib/code/errors';
import { setJsErrors } from 'DesignData/actions/EditorErrors';
/**
 * Toggle JS linter enabled/disabled.
 *
 * @param {Boolean} enable Optional value to force. Otherwise current value is toggled.
 */

export function toggleJsLint(enable) {
  return (dispatch, getState) => {
    let isEnabled;

    if (enable === !!enable) {
      isEnabled = enable;
    } else {
      const state = getState();
      const jsLinterSettings = getJSLinterSettings(state);
      isEnabled = !jsLinterSettings.isEnabled;
    }

    return dispatch({
      type: APPLICATION_SETTINGS_USER_JSLINTER_TOGGLE,
      data: {
        isEnabled
      }
    });
  };
}
/**
 * Sets the eslintrc JSON code parsing error.
 *
 * @param {CodeEditorError|Null} error
 */

export function setESLintConfigError(error) {
  return {
    type: APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_ERROR,
    error
  };
}
/**
 * Sets the errors from the ESLint Demo JS code.
 *
 * @param {Array.<react-codemirror/model/Annotations>} annotations
 */

export function setESLintDemoErrors(annotations) {
  const errors = !(annotations && annotations.length) ? EMPTY_ARRAY : annotations.map(anno => convertReactCodeMirrorAnnotationToCodeEditorError(anno, SETTINGS_ESLINT_DEMO_ID));
  return {
    type: APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_DEMO_ERRORS,
    data: {
      errors
    }
  };
}
/**
 * Updates the ESLint configuration JSON.
 *
 * @param {String} eslintConfig JSON
 */

export function updateESLintConfig(eslintConfig) {
  return dispatch => {
    const eslintConfigError = validateJSON(eslintConfig, SETTINGS_ESLINTRC_ID);
    dispatch(setESLintConfigError(eslintConfigError));

    if (!eslintConfigError) {
      dispatch({
        type: APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_UPDATE,
        data: {
          eslintConfig
        }
      });
    }
  };
}
/**
 * Processes and sets errors from ESLint.
 *
 * @param {String|Number}                             assetId
 * @param {String|Number}                             sessionId
 * @param {Array.<react-codemirror/model/Annotation>} annotations
 */

export function processESLintAnnotations(assetId, sessionId, annotations) {
  return dispatch => {
    const errors = annotations.map(anno => convertReactCodeMirrorAnnotationToCodeEditorError(anno, sessionId));
    dispatch(setJsErrors(assetId, sessionId, errors));
  };
}